import React from "react";

function SvgIcMapPoi029(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M21.5 24a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0121.5 24zm-11.173-5c-.138 0-.208-.104-.157-.232l.483-1.207.719-1.796c.098-.246.349-.484.627-.627.166-.086.343-.138.501-.138h7c.159 0 .335.052.502.138.277.143.528.381.627.627l.719 1.796.482 1.207c.052.128-.018.232-.157.232H10.327zm.173 5a1.5 1.5 0 11.001-3.001A1.5 1.5 0 0110.5 24zm13-4.5L23 19l-1.442-3.607C21.25 14.624 20.329 14 19.5 14h-7c-.828 0-1.749.624-2.057 1.393L9 19l-.5.5c-.275.276-.5.948-.5 1.5v5a1 1 0 001 1h2a1 1 0 001-1v-1h8v1a1 1 0 001 1h2a1 1 0 001-1v-5c0-.552-.224-1.224-.5-1.5zm-12-9.5c-.827 0-1.5-.673-1.5-1.5S10.673 7 11.5 7s1.5.673 1.5 1.5-.673 1.5-1.5 1.5m12.158-3H14.659A3.496 3.496 0 0011.5 5a3.5 3.5 0 100 7 3.496 3.496 0 003.159-2H17v2h2v-2h1v2h2v-2h1.659a3.476 3.476 0 00-.001-3"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi029;
